import React from 'react';

import { panel, root } from './Tabs.styles';

interface Tab {
  active?: boolean;
  content: React.ReactNode;
  href: string;
  label: string;
}

interface TabsProps {
  ariaLabel?: string;

  tabs: Tab[];
}

export const Tabs = ({ ariaLabel, tabs }: TabsProps) => {
  const activeTab = tabs.find((tab) => tab.active) ?? tabs[0];

  return (
    <div>
      <nav aria-label={ariaLabel} css={root}>
        <ul>
          {tabs.map((tab) => {
            return (
              <li key={tab.label}>
                <a aria-current={tab.active ? 'page' : undefined} href={tab.href}>
                  {tab.label}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
      <div css={panel}>{activeTab?.content}</div>
    </div>
  );
};
